import React, { useEffect, useState } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { FormInputDatePicker } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDatePicker';
import { FormInputCheckbox } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputCheckbox';
import { FormInputText } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputText';
import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import {
  selectIslandsCancel,
  selectPlacementLandsGtgDetails,
} from '../../../../../../../store/redux-store/placement-details/selectors';
const useStyles = makeStyles()({
  sectionTitle: {
    paddingBottom: '6px',
    paddingTop: '6px',
  },
  inputContainer: {
    paddingTop: '22px !important',
  },
  checkBoxesContainer: {
    paddingTop: '20px  !important',
  },
  divider: {
    height: '2px',
    margin: '10px 10px 10px 0px',
    backgroundColor: '#00000014',
  },
  subTitleStyle: {
    fontWeight: 'bold',
  },
  eVerifyUploadStyle: {
    height: '54px !important',
  },
});
export const I9Verification = props => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const selectLandsGtgDetails = useSelector(selectPlacementLandsGtgDetails);
  const selectiscancel = useSelector(selectIslandsCancel);
  const [supportDocOnFile, setSupportDocOnFile] = useState<boolean>(selectLandsGtgDetails?.supportDocUploaded || false);
  const [namesAndNumbersMatch, setNamesAndNumbersMatch] = useState<boolean>(
    selectLandsGtgDetails?.namesNumbersMatchI9 || false,
  );
  const [notAForeignTraveler, setNotAForeignTraveler] = useState<boolean>(
    selectLandsGtgDetails?.notForeignTraveler || false,
  );
  const [exceptionWaiveEvent, setExceptionWaiveEvent] = useState<boolean>(
    selectLandsGtgDetails?.missExpEvents || false,
  );
  const [finalAuditCompleted, setFinalAuditCompleted] = useState<boolean>(
    selectLandsGtgDetails?.i9FinalAuditCompleted || false,
  );
  
  const [isI9OnFIle, setIsI9OnFIle] = useState<boolean>(selectLandsGtgDetails?.i9Uploaded || false);
  const { getValues, setValue } = useFormContext();
  useEffect(() => {
    setValue('pI9OnFIle', selectLandsGtgDetails?.i9Uploaded);
    setValue('pSupportDocOnFile', selectLandsGtgDetails?.supportDocUploaded);
    setValue('pNamesAndNumbersMatch', selectLandsGtgDetails?.namesNumbersMatchI9);
    setValue('pEVerifyCode', selectLandsGtgDetails?.i9eVerifyCode);
    setValue('pEVerifyUpload', selectLandsGtgDetails?.eVerifyDate);
    setValue('pNotAForeignTraveler', selectLandsGtgDetails?.notForeignTraveler);
    setValue('pExceptionFollowUpDate', selectLandsGtgDetails?.foreignTravelerFUDate);
    setValue(
      'pSupportDocList',
      props.supportList?.find(x => x.Id === selectLandsGtgDetails?.supportDocListId?.toString())?.Description,
    );
    setValue('pExceptionWaiveEvent', selectLandsGtgDetails?.foreignTravelerEvent);
    setValue('pFinalAuditCompleted', selectLandsGtgDetails?.i9FinalAuditCompleted);
    setSupportDocOnFile(selectLandsGtgDetails?.supportDocUploaded || false);
    setNamesAndNumbersMatch(selectLandsGtgDetails?.namesNumbersMatchI9 || false);
    setNotAForeignTraveler(selectLandsGtgDetails?.notForeignTraveler || false);
    setExceptionWaiveEvent(selectLandsGtgDetails?.foreignTravelerEvent || false);
    setFinalAuditCompleted(selectLandsGtgDetails?.i9FinalAuditCompleted || false);
    setIsI9OnFIle(selectLandsGtgDetails?.i9Uploaded || false);
  }, [props.supportList, selectLandsGtgDetails, selectiscancel, setValue]);

  useEffect(() => {
    //if notAForeignTraveler = true clear two fields
    if (notAForeignTraveler) {
      setValue('pExceptionWaiveEvent', null);
      setExceptionWaiveEvent(false);
      setValue('pExceptionFollowUpDate', null);
    }
  }, [notAForeignTraveler, setValue]);
  const handleEVerifyCode = event => {
    setValue('pEVerifyCode', event.target.value, { shouldDirty: true });
    props.handleFieldChanges?.();
  };
  const handleEVerifyUpload = event => {
    setValue('pEVerifyUpload', event, { shouldDirty: true });
    props.handleFieldChanges?.();
  };
  const handleSupportDocList = event => {
    setValue('pSupportDocList', event.target.value, { shouldDirty: true });
    props.handleFieldChanges?.();
  };
  const handleI9OnFIle = event => {
    setValue('pI9OnFIle', event, { shouldDirty: true });
    setIsI9OnFIle(event);
    props.handleFieldChanges?.();
  };
  const handleSupportDocOnFile = event => {
    setValue('pSupportDocOnFile', event, { shouldDirty: true });
    setSupportDocOnFile(event);
    props.handleFieldChanges?.();
  };
  const handleExceptionWaiveEvent = event => {
    setValue('pExceptionWaiveEvent', event, { shouldDirty: true });
    setExceptionWaiveEvent(event);
    if (event === false) {
      setValue('pExceptionFollowUpDate', null, { shouldDirty: true });
    }
    props.handleFieldChanges?.();
  };
  const handleNamesAndNumbersMatch = event => {
    setValue('pNamesAndNumbersMatch', event, { shouldDirty: true });
    setNamesAndNumbersMatch(event);
    props.handleFieldChanges?.();
  };
  const handleFinalAuditCompleted = event => {
    setValue('pFinalAuditCompleted', event, { shouldDirty: true });
    setFinalAuditCompleted(event);
    props.handleFieldChanges?.();
  };
  const handleNotAForeignTraveler = event => {
    setValue('pNotAForeignTraveler', event, { shouldDirty: true });
    setNotAForeignTraveler(event);
    props.handleFieldChanges?.();
  };
  const handleExceptionFollowUpDate = event => {
    setValue('pExceptionFollowUpDate', event, { shouldDirty: true });
    props.handleFieldChanges?.();
  };
  return (
    <>
      <Box className={classes.sectionTitle}>
        <Typography variant="subtitle1" component="div" className={classes.subTitleStyle}>
          {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.i9Verification.title')}
        </Typography>
      </Box>
      <Divider variant="middle" className={classes.divider} />
      <LayoutGrid direction="column" className={classes.inputContainer}>
        {/* First -  Datepicker row */}
        <LayoutGridItem>
          <LayoutGrid>
            <LayoutGridItem md={4}>
              <FormInputText
                name={'pEVerifyCode'}
                label={t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.i9Verification.eVerifyCode',
                )}
                handleChange={handleEVerifyCode}
                require={false}
                readOnly={!props.hasEditPermission}
                inputValue={getValues('pEVerifyCode')}
                isCheckBox={true}
              />
            </LayoutGridItem>
            <LayoutGridItem md={4} style={{}}>
              <FormInputDatePicker
                name={'pEVerifyUpload'}
                label={t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.i9Verification.eVeriyUpload',
                )}
                handleChange={handleEVerifyUpload}
                require={false}
                readOnly={!props.hasEditPermission}
                customClass={classes.eVerifyUploadStyle}
                inputValue={getValues('pEVerifyUpload')}
                trailingIconVisible={true}
              />
            </LayoutGridItem>
            <LayoutGridItem md={4}>
              <FormInputDropdown
                name={'pSupportDocList'}
                label={t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.i9Verification.supportDocList',
                )}
                require={false}
                options={props.supportList}
                handleChange={handleSupportDocList}
                inputValue={
                  getValues('pSupportDocList') !== undefined
                    ? getValues('pSupportDocList')
                    : props.supportList[0]?.Description
                }
                readOnly={!props.hasEditPermission}
                isCheckBox={true}
              />
            </LayoutGridItem>
          </LayoutGrid>
        </LayoutGridItem>
        {/* Second - Checkboxes row */}
        <LayoutGridItem className={classes.checkBoxesContainer}>
          <LayoutGrid>
            <LayoutGridItem md={6}>
              <LayoutGrid direction="column">
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="pI9OnFIle"
                    isChecked={isI9OnFIle}
                    handleChecked={handleI9OnFIle}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.i9Verification.i9OnFile',
                    )}
                    isDisabled={!props.hasEditPermission}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="pSupportDocOnFile"
                    isChecked={supportDocOnFile}
                    handleChecked={handleSupportDocOnFile}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.i9Verification.supportDocOnFile',
                    )}
                    isDisabled={!props.hasEditPermission}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="pExceptionWaiveEvent"
                    isChecked={exceptionWaiveEvent}
                    handleChecked={handleExceptionWaiveEvent}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.i9Verification.exceptionWaiveEventSetForCoordinator',
                    )}
                    isDisabled={!props.hasEditPermission || notAForeignTraveler}
                  />
                </LayoutGridItem>
              </LayoutGrid>
            </LayoutGridItem>
            <LayoutGridItem md={6}>
              <LayoutGrid direction="column">
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="pNamesAndNumbersMatch"
                    isChecked={namesAndNumbersMatch}
                    handleChecked={handleNamesAndNumbersMatch}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.i9Verification.namesAndNumbersMatch',
                    )}
                    isDisabled={!props.hasEditPermission}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="pFinalAuditCompleted"
                    isChecked={finalAuditCompleted}
                    handleChecked={handleFinalAuditCompleted}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.i9Verification.finalAuditCompleted',
                    )}
                    isDisabled={!props.hasEditPermission}
                  />
                </LayoutGridItem>
                <LayoutGridItem>
                  <FormInputCheckbox
                    name="pNotAForeignTraveler"
                    isChecked={notAForeignTraveler}
                    handleChecked={handleNotAForeignTraveler}
                    checkboxLabel={t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.i9Verification.notForeignTraveler',
                    )}
                    isDisabled={!props.hasEditPermission}
                  />
                </LayoutGridItem>
              </LayoutGrid>
            </LayoutGridItem>
          </LayoutGrid>
        </LayoutGridItem>
        {/* Third -  Datepicker row */}
        <LayoutGridItem md={4}>
          <FormInputDatePicker
            name={'pExceptionFollowUpDate'}
            label={t(
              'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.i9Verification.exceptionFollowUpDate',
            )}
            handleChange={handleExceptionFollowUpDate}
            require={false}
            readOnly={!props.hasEditPermission || !exceptionWaiveEvent || notAForeignTraveler}
            inputValue={getValues('pExceptionFollowUpDate')}
            trailingIconVisible={true}
          />
        </LayoutGridItem>
      </LayoutGrid>
    </>
  );
};
